// utils/referral.js

// 官網可帶的「登入後導向」白名單：key = 官網 ?redirect= 的值，value = 站內路由
// 用白名單（而非直接吃網址）避免 open redirect：官網無法塞任意外部網址
export const POST_LOGIN_REDIRECTS = {
  plans: "/plans",           // 方案管理
  ai: "/strategy-summary",   // AI 策略助理
  coin: "/coins",            // MAS Coin 管理（官網帶 ?redirect=coin 或 coins 皆可）
  coins: "/coins",
  discord: "/profile/discord", // Discord 綁定分頁（會員中心第4分頁）— 給 Discord 導流用
};

export function saveReferralCodeFromUrl() {
  // ✅ 防呆：將網址中可能誤用的多個 ? 都替換成 &，確保 URLSearchParams 能正確解析
  const queryString = window.location.search.replace(/\?/g, '&');
  const params = new URLSearchParams(queryString);

  const ref = params.get("ref");
  if (ref) {
    localStorage.setItem("referralCode", ref);
  }

  // ✅ 通用「登入後導向」：官網帶 ?redirect=plans / ?redirect=ai（限白名單內）
  const redirect = params.get("redirect");
  if (redirect && POST_LOGIN_REDIRECTS[redirect]) {
    localStorage.setItem("postLoginRedirect", POST_LOGIN_REDIRECTS[redirect]);
  }

  // ✅ 舊版相容：官網帶 ?price= 仍導向方案頁（保留既有官網連結行為）
  const price = params.get("price");
  if (price || window.location.href.includes("price=")) {
    localStorage.setItem("postLoginRedirect", POST_LOGIN_REDIRECTS.plans);
  }
}

export function getReferralCode() {
  return localStorage.getItem("referralCode");
}

/**
 * ✅ 取得登入 / 註冊 / 2FA 成功後的跳轉路徑
 * 優先用 postLoginRedirect（官網帶 ?redirect=plans|ai 或 ?price= 設定，白名單見 POST_LOGIN_REDIRECTS）
 * 其次回退舊版 redirectPrice → /plans；都沒有則導預設 /mas-genie（MAS 精靈策略許願頁）
 *
 * 預設路由演進：
 *   2026-05-21 之前：/strategy-summary
 *   2026-05-21 之後：/mas-genie （MAS 精靈作為主入口，符合 product positioning）
 */
export function getAuthRedirectPath() {
  // 新版：通用導向目標（官網 ?redirect= 或 ?price= 設定）
  const target = localStorage.getItem("postLoginRedirect");
  if (target) {
    localStorage.removeItem("postLoginRedirect");
    return target;
  }
  // 舊版相容：殘留的 redirectPrice 標記仍導向方案頁
  if (localStorage.getItem("redirectPrice") === "true") {
    localStorage.removeItem("redirectPrice");
    return "/plans";
  }
  return "/mas-genie";
}
